<template>
  <div v-if="financingServicesEnabled" class="financial-services">
    <lease-block
      v-if="dealerSettings.vwpfsPrivateLeaseEnabled"
      :lease-type="leaseTypes.PRIVATE_LEASE"
    />
    <lease-block
      v-if="dealerSettings.vwpfsOperationalLeaseEnabled"
      :lease-type="leaseTypes.OPERATIONAL_LEASE"
    />
    <financing-block v-if="dealerSettings.vwpfsFinanceEnabled" />
    <insurance-block v-if="dealerSettings.vwpfsInsuranceEnabled" :brand-is-bwg="isBwgBrand" />
  </div>
</template>

<script>
import FinancingBlock from '@/components/generic/container/FinancialServices/Financing/FinancingBlock.vue'
import LeaseBlock from '@/components/generic/container/FinancialServices/Lease/LeaseBlock.vue'
import InsuranceBlock from '@/components/generic/container/FinancialServices/Insurance/InsuranceBlock.vue'
import { mapState } from 'vuex'
import { brandIsBwg } from '@/helpers/BrandHelper'
import constants from '@/utils/constants'

export default {
  components: {
    FinancingBlock,
    LeaseBlock,
    InsuranceBlock,
  },
  data() {
    return {
      leaseTypes: constants.leaseTypes,
    }
  },
  computed: {
    ...mapState('user', ['dealerId', 'dealerSettings']),
    financingServicesEnabled() {
      return (
        this.dealerSettings.vwpfsPrivateLeaseEnabled ||
        this.dealerSettings.vwpfsOperationalLeaseEnabled ||
        this.dealerSettings.vwpfsFinanceEnabled ||
        this.dealerSettings.vwpfsInsuranceEnabled
      )
    },
    isBwgBrand() {
      return brandIsBwg()
    },
  },
}
</script>

<style lang="scss" scoped>
.financial-services {
  margin-bottom: 2em;

  & > section {
    margin-bottom: 1em;
  }

  :deep() {
    .form-wrapper {
      position: relative;
    }

    .overlay {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }

    .disclaimer {
      font-size: $font-size-base * 0.75;
      padding: 0 1rem 1rem;
    }

    .errors {
      color: $color-danger;
      margin-top: -1rem;
      margin-bottom: 1rem;
    }
  }
}
</style>
